import { posterCardHue } from '../functions/posterCardHue.js'

// The SECONDARY ink of a home-board poster's BODY — empty-state copy,
// completed/list rows, the big legend numerals.
//
// HOME-POSTER-BRAND-1 measured the blanket `opacity: '.55'` grammar floor
// and replaced it, per family, with the smallest alpha of the poster's
// binary ink that clears ≥4.6:1 on ITS OWN hue (`POSTER_FAMILIES` third
// column in functions/homeWidgetHue.js, re-derived by
// __tests__/homePosterTokens.test.js). That pass moved the poster CAPTIONS
// (HomePosterCaption) but not the widget BODY, which kept the old `.55`:
// measured live at 4.20:1 for black `.55` on reminders yellow #E8CC56 at
// 15px/400 — under the 4.5:1 AA floor for normal text
// (HOME-POSTER-EMPTYSTATE-INK-1).
//
// This is the SHARED resolver both now use, so a body row can never drift
// from the header Subtitle again, and both follow a branded workspace's
// poster override at PAINT time (the step is an alpha of the
// `--color-poster<Family>Ink` pair token, not a baked rgba).
//
// The component carries `color` and NOTHING else on purpose: a body site
// adds `extends: 'HomePosterSoftInk'` to a row that already owns its tag,
// size, weight and layout, and only the ink comes from here.
//
// How it finds its poster: `_widget()` stamps `posterId: spec.id` on the
// poster card; `el.lookup(predicate)` walks ancestors with a ONE-argument
// predicate (never the `(el, s)` factory shape). Outside a poster (a
// neutral card such as the greeting, or a module widget) it falls back to
// the adaptive `caption` token — the neutral secondary ink that `opacity
// .55` on the neutral title ink used to approximate.
// The poster lookup itself lives in `functions/posterCardHue.js` — ONE lookup
// shared with the PRIMARY-ink sibling `components/HomePosterInk.js`
// (HOME-POSTER-NEUTRAL-INK-ON-HUE-1), so the two can never drift on how they
// find the card or on what they do outside one. A `components/` file exports
// component OBJECTS only (frank FA903); the caption component reuses this one
// through `HomePosterSoftInk.color`.
export const HomePosterSoftInk = {
  color: (el) => {
    const h = posterCardHue(el)
    return h ? h.inkSoft : 'caption'
  }
}
